/**
 * @namespace core/startup
 */

export const useStore_core_startup = defineStore('core/startup', {
  state: () => ({
    error: null,
    made: false,
  }),
})
